import React, { useEffect, useState } from 'react'
import { Button, Form, Input, Select, Space, Tooltip } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'

const CreatePage = ({ onSubmit, initialValues, isEdit, onDelete }) => {
  const [form] = Form.useForm()
  const [isProtectedPage, setIsProtectedPage] = useState(false)
  

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue({
        title: initialValues.title,
        slug: initialValues.slug,
        status: initialValues.status,
      })

      setIsProtectedPage([8, 9, 12, 13, 14].includes(Number(initialValues?.id)))

    } else {
      form.resetFields()
    }
  }, [initialValues, form])

  const handleFinish = (values) => {
    onSubmit(values)
  }

  return (
    <Form layout="vertical" form={form} onFinish={handleFinish}>
      
      <Form.Item
        label="Title"
        name="title"
        rules={[{ required: true, message: 'Please enter page title' }]}
      >
        <Input placeholder="Enter page title" />
      </Form.Item>

      <Form.Item
        label={
          <Space>
            Slug
            <Tooltip
              title={
                <>
                  <div><strong>Slug format rules:</strong></div>
                  <div>• <b>Page</b>: simple slug (e.g. <code>contact-us</code>)</div>
                  <div>• <b>Blog</b>: start with <code>blog/</code></div>
                  <div>• <b>Other</b>: structured path (e.g. <code>page/how-to-get</code>)</div>
                  <div>• <b>Note</b>: must not start with <code>/</code></div>
                </>
              }
            >
              <InfoCircleOutlined style={{ color: '#1890ff' }} />
            </Tooltip>
          </Space>
        }
        name="slug"
        rules={[
          { required: true, message: 'Please enter slug' },
          {
            validator: (_, value) => {
              if (!value) return Promise.resolve()
              if (value.startsWith('/')) {
                return Promise.reject(new Error('Slug must not start with "/"'))
              }
              return Promise.resolve()
            }
          }
        ]}
      >
        <Input
          placeholder="e.g. about-us or demo/page"
          disabled={isProtectedPage}
        />
      </Form.Item>

      <Form.Item
        label="Status"
        name="status"
        rules={[{ required: true }]}
      >
        <Select
          options={[
            { label: 'Active', value: 'active' },
            { label: 'Inactive', value: 'inactive' },
          ]}
          disabled={isProtectedPage}
        />
      </Form.Item>

      <Form.Item style={{ textAlign: 'right' }}>
        <Space>
          {isEdit && (
            <Button
              danger
              onClick={onDelete}
              disabled={isProtectedPage}
            >
              Delete
            </Button>
          )}

          <Button type="primary" htmlType="submit">
            {isEdit ? 'Update' : 'Save'}
          </Button>
        </Space>
      </Form.Item>
    </Form>
  )
}

export default CreatePage
